<template>
  <div id="app-pogs">
    <div class="app-pogs__notif" v-if="false">
      <button @click="show">heyy</button>
      <button @click="$toasted.show('Toasted !!')">toast</button>
    </div>

    <div class="app-pogs__content">
      <div class="inside">
        <one-column-layout class="app-pogs__content__nav"
                           :class="computedNavClasses"
                           :content-styles="[showPreview ? undefined : 'full-width']"
                           v-if="!isLoginPage"
                           >

          <div class="smd-branding__container"
               :class="{compact: isCompact}"
               slot="titleBar">
            <a href="https://www.pogsinc.org/" target="_blank"><div class="pogs-branding"></div></a>
          </div>

          <smd-navigation class="primary"
                          :compact="isCompact"
                          :items="navigationLookup"
                          @navToggle="isNavToggle"
                          >
            <div class="smd-spacer"></div>
            <div v-if="hasUpdate" class="smd-nav__item" @click="redirectToAbsoluteURL('https://pogs.seriousmd.com/')">
              <div class="smd-nav__notif alert">!</div>
              <p v-if="!isCompact" style="margin-left:18px ">Update Available</p>
            </div>
            <div class="smd-nav__item" @click="redirectToPage('contact-pogs-pnss')">
              <i class="smd-icon-list"></i>
              <p v-if="!isCompact">Census Questions</p>
            </div>
            <div class="smd-nav__item" @click="redirectToPage('contact-pogs-pnss-seriousmd')">
              <i class="smd-icon-action-report"></i>
              <p v-if="!isCompact">Technical Support</p>
            </div>
            <div class="smd-nav__item" @click="signout">
              <i class="smd-icon-action-logout"></i>
              <p v-if="!isCompact">Sign out</p>
            </div>
            <div class="smd-footer">
              <a href="https://seriousmd.com" target="_blank"><div class="smd-branding"></div></a>
              <br/>
              Version {{version}}a
            </div>
          </smd-navigation>

        </one-column-layout>

        <div class="app-pogs__content__page" v-if="loaded">
          <router-view @logged-in="loggedIn"/>
        </div>


          <div class="app-pogs__content__overlay"
               :class="{show : showOverlay}">

              <div class="cover" v-if="!loaded">
                <p>I'm preparing your workspace. Hang tight!</p>
                <smd-loading-dots></smd-loading-dots>
              </div>

              <router-view name="overlay" v-if="loaded"/>

          </div>

      </div>
    </div>

    <div class="app-pogs__status"></div>
  </div>
</template>

<script>
  import { ACTION_CHECK_UPDATES, GETTER_VERSION, GETTER_HAS_UPDATE } from "./store/modules/shared";
  import {ACTION_LOAD_REFERENCE_DATA} from "./store/modules/referencedata2";
  import {ACTION_LOAD_OPENCASE_PATIENT_COUNT} from "./store/modules/patients";

  import HtmlUtil from './utilities/html-util'
  import NavigationLookup from '../src/reference/pogs-navigations'
  import uiHelper from './mixins/uihelper'
  import Routes from './router/route-constants'


  export default {
    name: 'App',
    mixins: [uiHelper],
    data() {
      return {
        loaded: false,
        navigationLookup: null,
        mobileView: false,
        updateVersion: false
      }
    },
    methods: {
      loggedIn() {
        this.loadOpenCasePatients();
      },
      show(){
        this.$dialog.alert('Request completed!').then(function(dialog) {
          console.log('Closed');
        });
      },
      signout(){
        const router = this.$router;
        this.$dialog.confirm('Are you sure you want to sign out?', {cancelText: 'Cancel'})
                .then(function () {
                  localStorage.removeItem('pogs-user-token');
                  router.push({name: Routes.ROOT_ROUTE_LOGIN})
                }).catch();
      },
      redirectToPage(link) {
        window.open("http://" + window.location.hostname + ":" + window.location.port + "/" + link);
      },
      redirectToAbsoluteURL(link) {
        window.open(link);
      },
      isNavToggle() {
         return !this.$mq.desktop ? this.toggleNav() : undefined
      },
      loadOpenCasePatients() {
        this.$store.dispatch(ACTION_LOAD_OPENCASE_PATIENT_COUNT)
          .then((result) => {
            // NavigationLookup[0].notif.text = result.numOfPatientWithOpenCase;
            this.navigationLookup = NavigationLookup;
            console.log(result)
          });
      }
    },
    computed:{
      shouldDisplayNav(){
            const shoulBeMobileView = !this.$mq.desktop && this.mobileView;
            return shoulBeMobileView ? this.showNav ? this.toggleNav() : this.mobileView = false : this.showNav;
      },
      computedNavClasses(){
          return{
          'full-width': this.showPreview || this.shouldDisplayNav,
          'show-nav': this.$mq.desktop ? !this.showNav : this.shouldDisplayNav,
           'compact' :  this.isCompact,
          }
      },
      isLoginPage(){
        return this.$route.name === Routes.ROOT_ROUTE_LOGIN
      },
      isCompact() {
          return !this.$mq.desktop;
      },
      hasUpdate() {
        return this.$store.getters[GETTER_HAS_UPDATE];
      },
      version() {
        return this.$store.getters[GETTER_VERSION];
      },
    },
    mounted() {
      this.toggleOverlay();
      this.$store.dispatch(ACTION_LOAD_REFERENCE_DATA)
              .then(() => {
                this.loaded = true;
                this.toggleOverlay();
              });
      this.$store.dispatch(ACTION_CHECK_UPDATES)
          .then(() => {
            if (this.hasUpdate && !this.updateVersion) {
              this.updateVersion = true;
              this.$dialog.confirm(
                  'There is a new POGS Application Available. Login to https://pogs.seriousmd.com/ to download the latest version.',
                  {
                    title: 'Update Available',
                    okText: 'Download Update',
                    cancelText: 'Cancel'
                  }
              ).then(() => {
                window.open('https://pogs.seriousmd.com/', '_blank');
              });
            }
          });
      this.loadOpenCasePatients();
    },
    watch: {
      scrollToEl(nVal) {
        if(nVal) {
          HtmlUtil.scrollTo(nVal, 500, {offset: -15});
          this.setScrollToEl(null);
        }
      },
    }
  }
</script>
